/**
 * Cross-tab handoff of the matched evidence-chunk text from a Cogni search
 * result to the drug detail page, for chunk-level highlighting.
 *
 * The text can be large, so it is passed out-of-band (not in the URL).  It
 * MUST live in ``localStorage`` rather than ``sessionStorage``: opening a
 * result in a new tab (``window.open``) gives that tab a fresh, empty
 * ``sessionStorage``, so a sessionStorage handoff would be invisible to the
 * detail page.  ``localStorage`` is shared across same-origin tabs.
 *
 * ``take`` is one-shot — it reads and removes the entry so a stale chunk
 * never re-highlights on a later visit.
 */
// drugId is number from the search page (DrugResultV2) and string from the
// drug detail page (URL param) — the key is the same interpolated string
// either way, so accept both.
const keyFor = (drugId: number | string): string => `evidence-chunk-${drugId}`;

export function stashEvidenceChunk(drugId: number | string, chunkText: string): void {
  try {
    localStorage.setItem(keyFor(drugId), chunkText);
  } catch {
    /* localStorage may be unavailable (private mode / quota) — highlight is
       a nice-to-have, so degrade silently to no chunk-level highlight. */
  }
}

export function takeEvidenceChunk(drugId: number | string): string | null {
  try {
    const key = keyFor(drugId);
    const value = localStorage.getItem(key);
    if (value !== null) {
      localStorage.removeItem(key);
    }
    return value;
  } catch {
    return null;
  }
}
